import axios from 'axios'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    log:[],
    tab: 1,
    count: 0,
    filter: 'all',
    createFlag: false,
    permissionCreateFlag: false,
    admins: [],
    permissions: [],
    tempPermission: {
      id: null,
      level_id: null,
      authority: null,
      permission: {
        admins: null,
        banks: null,
        games: null,
        users: null,
        domains: null,
        events: null,
        transfers: null,
        bet_history: null,
        codes: null,
        ip: null,
        agents: null,
        supports: null,
        boards: null
      }
    },
    whitelists: [],
    tempWhitelist: {
      id: null,
      ip: null,
      description: null
    },
    whitelistCreateFlag: false,
    currentAdmin: {
      active: true,
      created_at: null,
      deleted_at: null,
      id: null,
      level_id: null,
      login_id: null,
      login_name: null,
      password: null
    },
    partialAdmin: {
      active: null,
      level_id: null,
      login_id: null,
      login_name: null,
      password: null,
      temp: null
    },
    logParams: {
      count:0,
      page: 1,
      row: 5,
      sortBy: 'id',
      sort: 'asc',
      filterBy: 'all',
      filter : '',
      date_to : '',
      date_from : ''
    },
    page: 1,
    row: 1,
    sortBy: 'id',
    sort: 'asc',
    filterBy: null,
    date_to : '',
      date_from : ''
  },
  getters: {
    getPermissions (state) {
      return state.permissions
    }
  },
  mutations: {
    SET_LOG (state, log) {
      state.log = log
    },
    SET_ADMINS (state, admins) {
      state.admins = admins
    },
    SET_TEMPPERMISSIONS (state, value) {
      let p = _.map(value, per => {
        return {
          level_id: per.level_id,
          permission: JSON.parse(per.permission)
        }
      })
      state.tempPermission = p
    },
    SET_PERMISSIONS (state, permissions) {
      let p = _.map(permissions, per => {
        return {
          id: per.id,
          level_id: per.level_id,
          authority: per.authority,
          permission: JSON.parse(per.permission)
        }
      })
      state.permissions = p
    },
    SET_PERMISSIONS_RAW (state, params) {
      _.remove(state.permissions, sperm => {
        return params.includes(sperm.id)
      })
    },
    SET_WHITELISTS (state, whitelists) {
      state.whitelists = whitelists
    },
    SET_TEMPWHITELIST (state, value) {
      state.tempWhitelist = value
    },
    SET_TAB (state, admins) {
      state.tab = admins
    },
    SET_PERMISSIONCREATEFLAG (state, value) {
      state.permissionCreateFlag = value
    },
    SET_WHITELISTCREATEFLAG (state, value) {
      state.whitelistCreateFlag = value
    },
    SET_CREATEFLAG (state, value) {
      state.createFlag = value
    },
    SET_CURRENTADMIN (state, value) {
      state.currentAdmin = value
    },
    SET_PARTIALADMIN (state, value) {
      state.partialAdmin = value
    },
    SET_PAGE (state, value) {
      state.page = value
    },
    SET_COUNT (state, value) {
      state.count = value
    },
    SET_ROW (state, value) {
      state.row = value
    },
    SET_SORTBY (state, value) {
      state.sortBy = value
    },
    SET_SORT (state, value) {
      state.sort = value
    },
    SET_FILTER (state, value) {
      state.filter = value
    },
    SET_FILTERBY (state, value) {
      state.filterBy = value
    },
    GET_ADMINS (state) {
      return state.admins
    },
    SET_LOGPARAMS (state, paramsLogs) {
      state.logParams = paramsLogs
    },
    SET_DATEFROM (state, value) {
      state.date_from = value
    },
    SET_DATETO (state, value) {
      state.date_to = value
    }
  },

  actions: {
    async setFilter ({ commit }, value) {
      commit('SET_FILTER', value)
    },
    async setTab ({ commit }, value) {
      commit('SET_TAB', value)
    },
    async setFilterBy ({ commit }, value) {
      commit('SET_FILTERBY', value)
    },
    async setPage ({ commit }, value) {
      commit('SET_PAGE', value)
    },
    async setCreateFlag ({ commit }, value) {
      commit('SET_CREATEFLAG', value)
    },
    async setPermissionCreateFlag ({ commit }, value) {
      commit('SET_PERMISSIONCREATEFLAG', value)
    },
    async setWhitelistCreateFlag ({ commit }, value) {
      commit('SET_WHITELISTCREATEFLAG', value)
    },
    async setCurrentAdmin ({ commit }, value) {
      commit('SET_CURRENTADMIN', value)
    },
    async setCurrentLog ({ commit }, value) {
      commit('SET_log', value)
    },
    async setPartialAdmin ({ commit }, value) {
      commit('SET_PARTIALADMIN', value)
    },
    async clearPartialAdmin ({commit}, value) {
       commit('SET_PARTIALADMIN', {
        active: null,
        level_id: null,
        login_id: null,
        login_name: null,
        password: null
      })
    },
    async setTempPermission ({ commit }, value) {
      commit('SET_TEMPPERMISSIONS', value)
    },
    async setTempWhitelist ({ commit }, value) {
      commit('SET_TEMPWHITELIST', value)
    },
    async setDateTo ({ commit }, value) {
      commit('SET_DATETO', value)
    },
    async setDateFrom ({ commit }, value) {
      commit('SET_DATEFROM', value)
    },
    async createWhitelist ({ commit, state, dispatch }) {
      try {
        await axios
          .post('/admins/whitelist/add', {
            ip: state.tempWhitelist.ip,
            description: state.tempWhitelist.description
          })

        dispatch('set', {
          page: state.page,
          row: state.row || 5,
          sortBy: state.sortBy || 'id',
          sort: state.sort || 'asc',
          filter: state.filter || '',
          filterBy: state.filterBy || ''
        })
      } catch (err) {
        console.log(err)
      }
    },
    async deletePermissions ({ commit, state, dispatch }, params) {
      try {
        await axios
          .delete('/admins/permission/', { data: params })
        commit('SET_PERMISSIONS_RAW', params)
      } catch (err) {
        console.log(err)
      }
    },
    async editWhitelist ({ commit, state, dispatch }, params) {
      try {
        await axios
          .delete('/admins/whitelist/drop?ip=' + params)
        dispatch('set', {
          page: state.page,
          row: state.row || 5,
          sortBy: state.sortBy || 'id',
          sort: state.sort || 'asc',
          filter: state.filter || '',
          filterBy: state.filterBy || ''
        })
      } catch (err) {
        console.log(err)
      }
    },
    async bulkUpdate ({commit},args) {
        try { 
         let type  = args.type
         let deleteArray = _.map( args.data, arg=>{
           
           let active = arg.active
           let deleted_at = arg.deleted_at
           
            if(type === 'setActive')
               active = true
            if(type === 'setInactive')
              active = false

            if(type === 'setDelete')
              deleted_at = new Date()
            if(type === 'setRestore')
              deleted_at = null
            
            if(active === 'true')
              active = true
            if(active === 'false')
              active = false
            
           return {
             'id' : arg.id,
             'login_id' : arg.login_id,
             active,
             deleted_at,
             'level_id' : arg.level_id
           }
         } )
           await axios.post('/admins/bulkupdate', deleteArray)
           return true
         } catch(e){
           console.log('Error', e)
         }
    },
    async deleteAdmin ({ commit, state, dispatch }, params) {
    //  return
      try {
        let res = await axios
          .delete('/admins/' + params.id)
        dispatch('fetchAdminList', {
          page: state.page,
          row: state.row || 5,
          sort_by: state.sortBy || 'id',
          sort: state.sort || 'asc',
          filter: state.filter || '',
          filter_by: state.filterBy || ''
        })
        return res
      } catch (err) {
        console.log(err)
      }
    },
    async createAdmin ({ commit, state }, pass = null) {
      return axios
          .post('/admins/', {
            login_id: state.partialAdmin.login_id,
            login_name: state.partialAdmin.login_name,
            level_id: state.partialAdmin.level_id,
            temp: (state.partialAdmin.password)?window.btoa(state.partialAdmin.password):null,
            password: state.partialAdmin.password,
            active: true
          })
          .then(r=>r)
          .catch(e=>{
            console.log(e)
          })
      /* try {
         let results = await axios
          .post('/admins/', {
            login_id: state.partialAdmin.login_id,
            login_name: state.partialAdmin.login_name,
            level_id: state.partialAdmin.level_id,
            password: state.partialAdmin.password,
            active: true
          })
        return results
      } catch (err) {
        console.log(err.code)
      }*/
    },
    async createPermissions ({ commit, state }, params) {
      // commit('SET_ADMINS', data)
      try {
        await axios
          .post('/admins/permission', {
            level_id: state.tempPermission.level_id,
            permission: JSON.stringify(state.tempPermission.permission)
          })
      } catch (err) {
        console.log(err)
      }
    },
    async editAdmin ({ commit, state }, newPass = null) {
      try {
        return await axios
          .patch('/admins/' + state.partialAdmin.id, {
            login_id: state.partialAdmin.login_id,
            login_name: state.partialAdmin.login_name,
            level_id: state.partialAdmin.level_id,
            temp : (newPass)?window.btoa(newPass):state.partialAdmin.temp,
            password: (newPass)?newPass:window.atob(state.partialAdmin.temp),
            active: state.partialAdmin.active
          })
      } catch (err) {
        console.log(err)
      }
    },
    async editPermissions ({ commit, state }, params) {
      try {
        if (!params.isDelete) {
          let permissionData = _.find(state.permissions, perm => perm.id === params.id)
          await axios
            .patch('/admins/permission/' + permissionData.id, {
              permission: JSON.stringify(permissionData.permission),
              authority: permissionData.authority
            })
        } else {
          await axios
            .delete('/admins/permission/' + params.id)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async sortAdminLog({ commit, state },args){
      if(args.isSort)
        state.logParams.sortBy = args.sortBy

      if(args.isSort)
        state.logParams.sort = (state.logParams.sort === 'asc') ? 'desc' : 'asc'
  
      let log = await axios
          .get('/admins/shit/?ppage=' + state.logParams.page +
            '&prow=' + state.logParams.row +
            '&psort_by=' + state.logParams.sortBy +
            '&psort=' + state.logParams.sort +
            '&pfilter=' + state.logParams.filter +
            '&pfilter_by=' + state.logParams.filterBy)
            let logShit = state.logParams
          state.logParams.count = log.data.count
          //commit('SET_LOGPARAMS', logShit)
          commit('SET_LOG', log.data.list)
    },
    async fetchAdminList ({ commit, state }, params){
      try {
        let p = params.stat ? params.stat : 'all'
        let dateBy = params.date_by || ''
        let dateFrom = params.date_from || ''
        let dateTo = params.date_to || ''
        let admins = await axios
          .get('/admins/list/'+p+'?page=' + params.page +
            '&row=' + params.rows +
            '&sort_by=' + params.sort_by +
            '&sort=' + params.sort +
            '&filter=' + params.q +
            '&filter_by=' + params.filter_by + 
            '&date_by=' + dateBy + 
            '&date_from=' + dateFrom + 
            '&date_to=' + dateTo)

        commit('SET_ADMINS', admins.data.list)
        commit('SET_COUNT', admins.data.count)
      } catch (err) {
        console.log(err)
      }
    },
    async set ({ commit, state }, params) {
      try {
        let p = params.stat ? params.stat : 'all'

        let dateBy = params.dateBy || ''
        let dateFrom = params.dateFrom || ''
        let dateTo = params.dateTo || ''
        let admins = await axios
        console.log('',params)
          .get('/admins/list/'+p,params)
        commit('SET_ADMINS', admins.data.list)
        
        commit('SET_PAGE', params.page)
        commit('SET_COUNT', admins.data.count)
        commit('SET_ROW', params.row)
        commit('SET_SORTBY', params.sortBy)
        commit('SET_SORT', params.sort)
        commit('SET_FILTER', params.filter)
        commit('SET_FILTERBY', params.filterBy)
         commit('SET_DATETO', params.date_to)
          commit('SET_DATEFROM', params.date_from)
        let permissions = await axios
          .get('/admins/permission')
        commit('SET_PERMISSIONS', permissions.data)
        let whitelist = await axios
          .get('/admins/whitelist')
        commit('SET_WHITELISTS', whitelist.data)
        let log = await axios
          .get('/admins/shit/?ppage=' + state.logParams.page +
            '&prow=' + state.logParams.row +
            '&psort_by=' + state.logParams.sortBy +
            '&psort=' + state.logParams.sort +
            '&pfilter=' + state.logParams.filter +
            '&pfilter_by=' + state.logParams.filterBy)
            let logShit = state.logParams
          state.logParams.count = log.data.count
          commit('SET_LOGPARAMS', logShit)
          commit('SET_LOG', log.data.list)

      } catch (err) {
        console.log(err)
      }
    }
  }
}
